import type { Security } from '@meridian/contracts';

import styles from './search-results.module.css';

import type { JSX } from 'react';

export interface SearchResultsProps {
  readonly results: readonly Security[];
  readonly activeIndex: number;
  readonly listboxId: string;
  readonly onSelect: (ticker: Security['ticker']) => void;
}

export function SearchResults({
  results,
  activeIndex,
  listboxId,
  onSelect,
}: SearchResultsProps): JSX.Element | null {
  if (results.length === 0) return null;
  return (
    <div id={listboxId} className={styles['list']} role="listbox" aria-label="Search results">
      {results.map((row, i) => (
        <button
          key={row.ticker}
          id={`${listboxId}-option-${String(i)}`}
          type="button"
          role="option"
          aria-selected={i === activeIndex}
          tabIndex={-1}
          className={styles['item']}
          data-active={i === activeIndex ? 'true' : 'false'}
          onClick={() => {
            onSelect(row.ticker);
          }}
        >
          <span className={styles['ticker']}>{row.ticker}</span>
          <span className={styles['name']}>{row.name}</span>
        </button>
      ))}
    </div>
  );
}
